module.exports = __webpack_public_path__ + "img/section.782ad2a8.svg";